// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="Icon.d.ts"/>
import React, { forwardRef } from 'react'

import { ReactComponent as AUFlag } from '../images/region-popup/au-round.svg'
import { ReactComponent as BRFlag } from '../images/region-popup/br-round.svg'
import { ReactComponent as EEAFlag } from '../images/region-popup/eea-round.svg'
import { ReactComponent as GLOBALFlag } from '../images/region-popup/global-round.svg'
import { ReactComponent as SGFlag } from '../images/region-popup/sg-round.svg'
import { ReactComponent as TRFlag } from '../images/region-popup/tr-round.svg'
import { ReactComponent as USFlag } from '../images/region-popup/us-round.svg'
import Box, { BoxProps } from './Box'
import { ReactComponent as AddCircle } from './icons/add-circle.svg'
import { ReactComponent as ArrowDown } from './icons/arrow-down.svg'
import { ReactComponent as ArrowRight } from './icons/arrow-right.svg'
import { ReactComponent as ArrowUp } from './icons/arrow-up.svg'
import { ReactComponent as CaretRight } from './icons/caretRight.svg'
import { ReactComponent as Check } from './icons/check.svg'
import { ReactComponent as CheckBox } from './icons/checkbox.svg'
import { ReactComponent as CheckBoxUncheck } from './icons/checkbox-uncheck.svg'
import { ReactComponent as ChevronDown } from './icons/chevron-down.svg'
import { ReactComponent as ChevronDownNarrow } from './icons/chevron-down-narrow.svg'
import { ReactComponent as ChevronLeftNarrow } from './icons/chevron-left-narrow.svg'
import { ReactComponent as ChevronRight } from './icons/chevron-right.svg'
import { ReactComponent as ChevronRightNarrow } from './icons/chevron-right-narrow.svg'
import { ReactComponent as ChevronUp } from './icons/chevron-up.svg'
import { ReactComponent as ChevronUpDown } from './icons/chevron-up-down.svg'
import { ReactComponent as ChevronUpNarrow } from './icons/chevron-up-narrow.svg'
import { ReactComponent as Close } from './icons/close.svg'
import { ReactComponent as Discord } from './icons/discord.svg'
import { ReactComponent as ExchangeSpin } from './icons/exchange-spin.svg'
import { ReactComponent as Facebook } from './icons/facebook.svg'
import { ReactComponent as Geolocation } from './icons/geolocation.svg'
import { ReactComponent as Instagram } from './icons/instagram.svg'
import { ReactComponent as KakaoTalk } from './icons/kakaotalk.svg'
import { ReactComponent as LinkedIn } from './icons/linkedin.svg'
import { ReactComponent as Menu } from './icons/menu.svg'
import { ReactComponent as MinusCircle } from './icons/minus-circle.svg'
import { ReactComponent as NewTab } from './icons/new-tab.svg'
import { ReactComponent as PopoverArrowDown } from './icons/popover-arrow-down.svg'
import { ReactComponent as PopoverArrowRight } from './icons/popover-arrow-right.svg'
import { ReactComponent as PopoverArrowUp } from './icons/popover-arrow-up.svg'
import { ReactComponent as Reddit } from './icons/reddit.svg'
import { ReactComponent as Search } from './icons/search.svg'
import { ReactComponent as SearchClose } from './icons/search-close.svg'
import { ReactComponent as Select } from './icons/select.svg'
import { ReactComponent as Telegram } from './icons/telegram.svg'
import { ReactComponent as Twitter } from './icons/twitter.svg'
import { ReactComponent as Youtube } from './icons/youtube.svg'

const createIcon = (Component) => {
  const FowardedIcon = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
    <Box display="inline-flex" ref={ref} {...props}>
      <Component />
    </Box>
  ))

  FowardedIcon.displayName = 'Icon'

  return FowardedIcon
}

export default {
  ChevronDown: createIcon(ChevronDown),
  ChevronDownNarrow: createIcon(ChevronDownNarrow),
  ChevronUp: createIcon(ChevronUp),
  ChevronUpNarrow: createIcon(ChevronUpNarrow),
  ChevronRight: createIcon(ChevronRight),
  ChevronRightNarrow: createIcon(ChevronRightNarrow),
  ChevronLeftNarrow: createIcon(ChevronLeftNarrow),
  ChevronUpDown: createIcon(ChevronUpDown),
  ArrowRight: createIcon(ArrowRight),
  ArrowDown: createIcon(ArrowDown),
  ArrowUp: createIcon(ArrowUp),
  NewTab: createIcon(NewTab),
  AddCircle: createIcon(AddCircle),
  MinusCircle: createIcon(MinusCircle),
  Check: createIcon(Check),
  Youtube: createIcon(Youtube),
  Twitter: createIcon(Twitter),
  Telegram: createIcon(Telegram),
  Reddit: createIcon(Reddit),
  LinkedIn: createIcon(LinkedIn),
  KakaoTalk: createIcon(KakaoTalk),
  Instagram: createIcon(Instagram),
  Facebook: createIcon(Facebook),
  Discord: createIcon(Discord),
  Menu: createIcon(Menu),
  PopoverArrowUp: createIcon(PopoverArrowUp),
  PopoverArrowRight: createIcon(PopoverArrowRight),
  PopoverArrowDown: createIcon(PopoverArrowDown),
  Close: createIcon(Close),
  Geolocation: createIcon(Geolocation),
  CaretRight: createIcon(CaretRight),
  ExchangeSpin: createIcon(ExchangeSpin),
  CheckBox: createIcon(CheckBox),
  CheckBoxUncheck: createIcon(CheckBoxUncheck),
  Select: createIcon(Select),
  Search: createIcon(Search),
  SearchClose: createIcon(SearchClose),
  SGFlag: createIcon(SGFlag),
  USFlag: createIcon(USFlag),
  AUFlag: createIcon(AUFlag),
  TRFlag: createIcon(TRFlag),
  EEAFlag: createIcon(EEAFlag),
  BRFlag: createIcon(BRFlag),
  GLOBALFlag: createIcon(GLOBALFlag),
}
